import { BusinessTypeEnum } from "~/__generated__/graphql"
import { useCurrentUserMaybe } from "~/auth/CurrentUserContext"
import { castingCallsMyCallsPath, dashboardPath, myRosterPath } from "./paths"

// The default landing page for a signed-in user. Agencies without Marketplace
// access can't see the Dashboard (ZAN-854), so we land them somewhere they can
// actually use: talent agencies on the free Roster plan get My Roster (they
// can't post casting calls), brands/marketing get My Casting Calls. Everyone
// else (Marketplace, comped agencies, admins) keeps the Dashboard as home.
export const useHomePath = (): string => {
  const { currentUser } = useCurrentUserMaybe()

  if (currentUser && !currentUser.canAccessMarketplacePages.value) {
    return currentUser.agency?.businessType === BusinessTypeEnum.Talent
      ? myRosterPath({})
      : castingCallsMyCallsPath({})
  }

  return dashboardPath({})
}
